import React from "react";

export function readableProjectName({
  // Props
  name,
  jiraId,
}) {
  if (jiraId) {
    return `${name} (${jiraId})`;
  }
  return name;
}

export default React.memo(readableProjectName);
